module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B7SRRX7.236ef0dd.jpg";